import { render, staticRenderFns } from "./KaryawanEdit.vue?vue&type=template&id=387a5ec2&scoped=true"
import script from "./KaryawanEdit.vue?vue&type=script&lang=js"
export * from "./KaryawanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387a5ec2",
  null
  
)

export default component.exports